import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.saaspass-connect-login', {
        url: '/saaspassConnectLogin?continue&client&type&ilenabled&plenabled',
        component: 'publicSaaspassConnectLogin',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/saaspass-connect-login/saaspass-connect-login.state.js